import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { I18nProvider } from './i18n';
import './styles/app.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Beim Sprachwechsel wird die Oberfläche neu aufgebaut, damit alle Zahlen und Texte umschalten */}
    <I18nProvider>{(lang) => <App key={lang} />}</I18nProvider>
  </StrictMode>,
);
